import gql from 'graphql-tag'

import BlockContent from '@Queries/cms/fragments/BlockContent.fragment'
import Fields from '@Queries/cms/fragments/Fields.fragment'
import MoneyContent from '@Queries/cms/fragments/MoneyContent.fragment'
import OpenGraphContent from '@Queries/cms/fragments/OpenGraphContent.fragment'
import ProductContent from '@Queries/cms/fragments/ProductContent.fragment'
import ReferenceContent from '@Queries/cms/fragments/ReferenceContent.fragment'
import WordbookFragment from '@Queries/wordbook/wordbook.fragment'

export default gql`
  ${ProductContent}
  ${OpenGraphContent}
  ${MoneyContent}
  ${ReferenceContent}
  ${Fields}
  ${BlockContent}
  ${WordbookFragment}

  query facetDescriptions($id: ID){
    page(type: FACET_DESCRIPTION, id: $id) {
      type
      id
      seo {
        description
      }
      image {
        url
        dimensions {
          width
          height
        }
      }
      blocks {
        ...BlockContent
        ... on GlobalBlock {
          id
          type
          blocks {
            ...BlockContent
          }
        }
        ... on ProductListBlock {
          extraBlocks {
            ...BlockContent
          }
        }
      }
    }
  }
`
